<script setup>
import { Head } from '@inertiajs/vue3';

defineProps({ title: String });
</script>

<template>
    <Head :title="title ? `${title} - My10x` : 'My10x'">
        <slot />
    </Head>
</template>
